import ALaCartaView from "./aLaCartaView";


export default function ShopComponent(props) {

    return (
        <div>
            <ALaCartaView />
        </div>
    )
}